exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Search-local__search--3PCef {\n  background-color: #3c4e64;\n  border-radius: 5px;\n  padding: 2.125rem 7.25rem 1.25rem;\n  margin-bottom: 3.25rem; }\n\n.Search-local__searchArea--261hl {\n  position: relative;\n  margin-bottom: 0.75rem; }\n  .Search-local__searchArea--261hl input {\n    height: 1.25rem !important;\n    -webkit-box-shadow: none !important;\n            box-shadow: none !important; }\n", ""]);

// exports
exports.locals = {
	"search": "Search-local__search--3PCef",
	"searchArea": "Search-local__searchArea--261hl"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/media/media/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Community/Header/Search/Search.local.scss
// module id = 356
// module chunks = 0